import graphql from './graphql';
import courseSetEnterpriseType from './Request/Course_SetEnterpriseType';

const coursesByEnterprise = coursesEnterprise =>
  coursesEnterprise.map(course => [
    course.name || '',
    course.Enterprise.Terminals[0].name || '',
    course.duration || 0,
    course.CourseCategory.name || 'sin categoría',
    course.id,
    course?.CourseType?.type === 'Enterprise',
    course.isChecked,
  ]);

const mapCategories = coursesEnterprise => coursesEnterprise.map(category => category.name || '');

export const fetch = async () => {
  const promises = [];

  promises.push(
    graphql(
      'Course_listCoursesByEnterprise',
      'name Enterprise { Terminals {name}} duration CourseCategory {name} CourseType{type} isChecked id',
      'query'
    ).catch(() => ({ Course_listCoursesByEnterprise: [] }))
  );
  promises.push(graphql('CourseCategory_list', 'name', 'query').catch(() => ({ CourseCategory_list: [] })));

  const data = await Promise.all(promises);
  const coursesByEnterprises = coursesByEnterprise(data[0].Course_listCoursesByEnterprise);
  const categories = mapCategories(data[1].CourseCategory_list);

  return { coursesByEnterprises, categories };
};

// TO-DO: Verify courses to be added aren't already assigned to department/job title
export const update = async coursesData => courseSetEnterpriseType(coursesData);
